import { useEffect, useState } from 'react';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FiltersBarQuickFiltersItem from './FiltersBarQuickFiltersItem';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FiltersBarQuickFilters = ({
  fixedComponents,
  isQuickFilterVisible,
  quickFiltersComponents
}) => {
  const [isQuickFiltersVisibilityInitialized, setIsQuickFiltersVisibilityInitialized] = useState(false);
  useEffect(() => {
    if (!isQuickFiltersVisibilityInitialized) {
      setIsQuickFiltersVisibilityInitialized(Object.keys(quickFiltersComponents).every(propertyName => isQuickFilterVisible(propertyName) !== undefined));
    }
  }, [isQuickFilterVisible, isQuickFiltersVisibilityInitialized, quickFiltersComponents]);
  if (!isQuickFiltersVisibilityInitialized) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  return /*#__PURE__*/_jsxs(Flex, {
    blockSize: "100%",
    gap: "200",
    "data-selenium-test": "FiltersBar-container",
    children: [/*#__PURE__*/_jsx(View, {
      overflow: "hidden",
      children: Object.entries(quickFiltersComponents).map(([propertyName, quickFilterComponent], index) => /*#__PURE__*/_jsx(FiltersBarQuickFiltersItem, {
        isVisible: isQuickFilterVisible(propertyName),
        isFirst: index === 0,
        children: quickFilterComponent
      }, `${propertyName}-quick-filter-component`))
    }), fixedComponents]
  });
};
export default FiltersBarQuickFilters;